// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276,9 12,15 18,9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-preview-page {
  min-height: 100vh;
  background: #1a1a1a;
  color: #fff;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: #2a2a2a;
  border-bottom: 1px solid #444;
}

.header-content h1 {
  margin: 0 0 5px 0;
  font-size: 24px;
  color: #fff;
}

.header-content p {
  margin: 0;
  color: #ccc;
  font-size: 14px;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: #e9ecef !important;
  border: 1px solid #adb5bd !important;
  color: #343a40 !important;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.back-button:hover {
  background-color: #dee2e6 !important;
  border-color: #6c757d !important;
  color: #212529 !important;
  transform: translateY(-1px);
}

.preview-main {
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.video-container {
  position: relative;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
  aspect-ratio: 16/9;
}

.preview-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #000;
}

.preview-top-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  background: #1e1e1e;
  border-radius: 8px;
  margin-bottom: 15px;
  gap: 20px;
  border: 1px solid #333;
  min-height: 60px;
}

.generate-config-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #ffc107;
  color: #212529;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);
}

.generate-config-button:hover:not(:disabled) {
  background: #e0a800;
  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.4);
  transform: translateY(-1px);
}

.generate-config-button:disabled {
  background: #6c757d;
  color: #fff;
  cursor: not-allowed;
  opacity: 0.8;
  transform: none;
  box-shadow: none;
}

.generate-config-button svg {
  flex-shrink: 0;
}

.config-management-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.delete-config-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
}

.delete-config-button:hover:not(:disabled) {
  background: #c82333;
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4);
  transform: translateY(-1px);
}

.delete-config-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.8;
  transform: none;
  box-shadow: none;
}

.delete-config-button svg {
  flex-shrink: 0;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #2a2a2a;
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  color: #fff;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.modal-content h3 {
  margin: 0 0 16px 0;
  color: #fff;
  font-size: 18px;
}

.modal-content p {
  margin: 0 0 12px 0;
  color: #ccc;
  line-height: 1.5;
}

.modal-warning {
  color: #ffc107 !important;
  font-size: 13px;
  margin-bottom: 20px !important;
}

.modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.modal-cancel-button {
  padding: 10px 16px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.modal-cancel-button:hover:not(:disabled) {
  background: #5a6268;
}

.modal-delete-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}

.modal-delete-button:hover:not(:disabled) {
  background: #c82333;
}

.modal-delete-button:disabled,
.modal-cancel-button:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

.preview-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  background: #2a2a2a;
  border-radius: 8px;
  margin-bottom: 30px;
}

.preview-controls .play-button {
  margin-right: 5px;
}


.play-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background 0.2s;
}

.play-button:hover {
  background: #218838;
}

.generate-video-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background 0.2s;
}

.generate-video-button:hover:not(:disabled) {
  background: #c82333;
}

.generate-video-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.8;
}

.generate-video-button.generating {
  background: #ffc107;
  color: #212529;
}

.generate-video-button .spinning {
  animation: spin 1s linear infinite;
}

.speed-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.speed-selector label {
  font-size: 12px;
  color: #ccc;
  margin: 0;
}

.speed-select {
  padding: 8px 12px;
  background: #2a2a2a;
  color: #fff;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s;
}

.speed-select:hover {
  border-color: #007acc;
}

.speed-select:focus {
  outline: none;
  border-color: #007acc;
  box-shadow: 0 0 0 2px rgba(0, 122, 204, 0.2);
}

.language-selector {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.language-selector label {
  font-size: 12px;
  color: #ccc;
  margin: 0;
}

.language-select {
  padding: 8px 12px;
  padding-right: 30px;
  background: #2a2a2a;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  color: #fff !important;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s;
  min-width: 140px;
  appearance: none;
  font-weight: 500;
}

.language-select:hover {
  border-color: #007acc;
}

.language-select:focus {
  outline: none;
  border-color: #007acc;
  box-shadow: 0 0 0 2px rgba(0, 122, 204, 0.2);
}

.language-select option {
  background: #2a2a2a !important;
  color: #fff !important;
  padding: 8px 12px;
  font-weight: 500;
}

.language-select option:checked,
.language-select option:selected {
  background: #007acc !important;
  color: #fff !important;
}

/* Additional specificity for better cross-browser support */
select.language-select {
  color: #fff !important;
  background-color: #2a2a2a !important;
}

select.language-select:focus {
  color: #fff !important;
  background-color: #2a2a2a !important;
}

.item-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.item-counter {
  font-size: 14px;
  color: #ccc;
}

.item-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.navigation-controls {
  display: flex;
  gap: 10px;
}

.nav-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #007acc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.nav-button:hover:not(:disabled) {
  background: #005a9e;
}

.nav-button:disabled {
  background: #555;
  cursor: not-allowed;
  opacity: 0.6;
}

.timeline-items-list {
  background: #2a2a2a;
  border-radius: 8px;
  padding: 20px;
}

.timeline-items-list h3 {
  margin: 0 0 20px 0;
  color: #fff;
  font-size: 18px;
}

.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}

.timeline-item-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px;
  background: #3a3a3a;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
  position: relative;
}

.timeline-item-card:hover {
  background: #444;
}

.timeline-item-card.current {
  border-color: #28a745;
  background: #2d4a3d;
}

.item-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #007acc;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
}

.timeline-item-card.current .item-number {
  background: #28a745;
}

.timeline-item-card.has-generated-video {
  border-left: 4px solid #28a745;
}

.timeline-item-card.has-generated-video.current {
  border-left: 4px solid #fff;
}

/* New classes for language-specific configuration availability */
.timeline-item-card.has-config-available {
  border-left: 4px solid #28a745;
}

.timeline-item-card.has-config-available.current {
  border-left: 4px solid #fff;
}

.timeline-item-card.has-config-missing {
  border-left: 4px solid #dc3545;
}

.timeline-item-card.has-config-missing.current {
  border-left: 4px solid #fff;
}

.item-details {
  flex: 1 1;
  min-width: 0;
}

.item-type {
  font-weight: 500;
  color: #fff;
  font-size: 14px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: 6px;
}

.generated-video-indicator {
  display: inline-flex;
  align-items: center;
  color: #28a745;
  opacity: 0.8;
}

.generated-video-indicator svg {
  filter: drop-shadow(0 0 2px rgba(40, 167, 69, 0.5));
}

.item-time {
  font-size: 12px;
  color: #ccc;
  margin-top: 2px;
}

.item-text {
  font-size: 12px;
  color: #aaa;
  margin-top: 4px;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Edit Item Button */
.edit-item-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 122, 204, 0.9);
  border: none;
  border-radius: 4px;
  padding: 6px;
  cursor: pointer;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.2s ease;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.timeline-item-card:hover .edit-item-button {
  opacity: 1;
  transform: scale(1);
}

.edit-item-button:hover {
  background: #007acc;
  transform: scale(1.1);
}

.edit-item-button svg {
  display: block;
}

.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #444;
  border-top: 4px solid #007acc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container h2 {
  color: #ff6b6b;
  margin-bottom: 10px;
}

.error-container p {
  color: #ccc;
  margin-bottom: 20px;
}

/* Quick Preview button in Timeline */
.timeline-controls {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  padding: 0 10px;
}

.quick-preview-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
}

.quick-preview-button:hover {
  background: #218838;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.4);
  transform: translateY(-1px);
}

.quick-preview-button svg {
  flex-shrink: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .preview-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .preview-controls {
    flex-direction: column;
    gap: 20px;
  }
  
  .preview-controls > button {
    width: 100%;
    justify-content: center;
  }
  
  .navigation-controls {
    justify-content: center;
  }
  
  .items-grid {
    grid-template-columns: 1fr;
  }
  
  .preview-main {
    padding: 20px 15px;
  }
}

/* Bulk Render Button Styles */
.bulk-render-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  min-height: 40px;
  line-height: 1.2;
}

.bulk-render-button:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.bulk-render-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.8;
  transform: none;
}

.bulk-render-button.bulk-rendering {
  background: #ffc107;
  color: #212529;
}

.bulk-render-button .spinning {
  animation: spin 1s linear infinite;
}

.bulk-render-button svg {
  flex-shrink: 0;
}

/* Integrated Render Controls (Dropdown + Button) */
.render-controls-group {
  display: flex;
  align-items: center;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 4px;
  overflow: hidden;
  transition: border-color 0.2s;
}

.render-controls-group:hover {
  border-color: #007acc;
}

.speed-select-integrated {
  padding: 8px 12px;
  background: transparent;
  color: #fff;
  border: none;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  min-width: 90px;
  border-right: 1px solid #444;
}

.speed-select-integrated:focus {
  background: rgba(0, 122, 204, 0.1);
}

.render-button-integrated {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #dc3545;
  color: #fff;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  min-height: 40px;
  line-height: 1.2;
}

.render-button-integrated:hover:not(:disabled) {
  background: #c82333;
  color: #fff;
}

.render-button-integrated:disabled {
  background: #6c757d;
  color: #fff;
  cursor: not-allowed;
  opacity: 0.8;
}

.render-button-integrated.rendering {
  background: #ffc107;
  color: #212529;
}

.render-button-integrated .spinning {
  animation: spin 1s linear infinite;
}

.render-button-integrated svg {
  flex-shrink: 0;
}

/* Bulk Render Button (Right Aligned) */
.bulk-render-button-right {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  line-height: 1.2;
  margin-left: auto; /* This pushes it to the extreme right */
}

.bulk-render-button-right:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.bulk-render-button-right:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.8;
  transform: none;
}

.bulk-render-button-right.bulk-rendering {
  background: #ffc107;
  color: #212529;
}

.bulk-render-button-right .spinning {
  animation: spin 1s linear infinite;
}

.bulk-render-button-right svg {
  flex-shrink: 0;
}

/* Responsive adjustments for bulk render button and integrated controls */
@media (max-width: 768px) {
  .language-selector {
    flex-direction: column;
    gap: 8px;
  }
  
  .bulk-render-button {
    padding: 6px 12px;
    font-size: 12px;
    min-height: 36px;
  }
  
  .render-controls-group {
    flex-direction: column;
  }
  
  .speed-select-integrated {
    border-right: none;
    border-bottom: 1px solid #444;
    min-width: auto;
    width: 100%;
  }
  
  .render-button-integrated {
    padding: 6px 12px;
    font-size: 12px;
    min-height: 36px;
    width: 100%;
    justify-content: center;
  }
}

/* Bulk Generation Styles */
.bulk-gen-button-container {
  margin-left: 15px;
}

.bulk-gen-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.bulk-gen-button:hover:not(:disabled) {
  background: #45a049;
  transform: translateY(-1px);
}

.bulk-gen-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Bulk Generation Modal */
.bulk-gen-modal {
  min-width: 600px;
  max-width: 700px;
}

.bulk-gen-form {
  margin: 20px 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #fff;
}

.language-checkboxes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding: 12px;
  background: #2a2a2a;
  border-radius: 6px;
  border: 1px solid #444;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.checkbox-label:hover {
  background: #3a3a3a;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
}

.checkbox-text {
  font-size: 14px;
  color: #fff;
}

.voice-model-select {
  width: 100%;
  padding: 10px;
  background: #2a2a2a;
  color: #fff;
  border: 1px solid #444;
  border-radius: 6px;
  font-size: 14px;
}

.voice-model-select:focus {
  outline: none;
  border-color: #4CAF50;
}

/* Progress Display */
.progress-display {
  margin-top: 20px;
  padding: 15px;
  background: #2a2a2a;
  border-radius: 6px;
  border: 1px solid #444;
}

.progress-info {
  margin-bottom: 10px;
  font-size: 14px;
  color: #fff;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #444;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4CAF50, #45a049);
  transition: width 0.3s ease;
}

.progress-text {
  text-align: center;
  font-size: 12px;
  color: #ccc;
}

.modal-confirm-button {
  background: #4CAF50;
  color: white;
}

.modal-confirm-button:hover:not(:disabled) {
  background: #45a049;
}

.modal-confirm-button:disabled {
  background: #666;
  cursor: not-allowed;
}

/* Test Mode Switch */
.test-mode-switch {
  display: flex;
  align-items: center;
  margin: 0 10px;
}

.test-mode-switch label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px 12px;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.test-mode-switch label:hover {
  background: #3a3a3a;
  border-color: #555;
}

.test-mode-switch input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
  accent-color: #007acc;
}`, "",{"version":3,"sources":["webpack://./src/QuickPreview.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yDAAqR;EACrR,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAGhB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iEAAiE;AACjE;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB","sourcesContent":[".quick-preview-page {\n  min-height: 100vh;\n  background: #1a1a1a;\n  color: #fff;\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  background: #2a2a2a;\n  border-bottom: 1px solid #444;\n}\n\n.header-content h1 {\n  margin: 0 0 5px 0;\n  font-size: 24px;\n  color: #fff;\n}\n\n.header-content p {\n  margin: 0;\n  color: #ccc;\n  font-size: 14px;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background-color: #e9ecef !important;\n  border: 1px solid #adb5bd !important;\n  color: #343a40 !important;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.back-button:hover {\n  background-color: #dee2e6 !important;\n  border-color: #6c757d !important;\n  color: #212529 !important;\n  transform: translateY(-1px);\n}\n\n.preview-main {\n  padding: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.video-container {\n  position: relative;\n  background: #000;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 30px;\n  aspect-ratio: 16/9;\n}\n\n.preview-video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: #000;\n}\n\n.preview-top-controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 20px;\n  background: #1e1e1e;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  gap: 20px;\n  border: 1px solid #333;\n  min-height: 60px;\n}\n\n.generate-config-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #ffc107;\n  color: #212529;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);\n}\n\n.generate-config-button:hover:not(:disabled) {\n  background: #e0a800;\n  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.4);\n  transform: translateY(-1px);\n}\n\n.generate-config-button:disabled {\n  background: #6c757d;\n  color: #fff;\n  cursor: not-allowed;\n  opacity: 0.8;\n  transform: none;\n  box-shadow: none;\n}\n\n.generate-config-button svg {\n  flex-shrink: 0;\n}\n\n.config-management-buttons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.delete-config-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);\n}\n\n.delete-config-button:hover:not(:disabled) {\n  background: #c82333;\n  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.4);\n  transform: translateY(-1px);\n}\n\n.delete-config-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.8;\n  transform: none;\n  box-shadow: none;\n}\n\n.delete-config-button svg {\n  flex-shrink: 0;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #2a2a2a;\n  border-radius: 8px;\n  padding: 24px;\n  max-width: 400px;\n  width: 90%;\n  color: #fff;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.modal-content h3 {\n  margin: 0 0 16px 0;\n  color: #fff;\n  font-size: 18px;\n}\n\n.modal-content p {\n  margin: 0 0 12px 0;\n  color: #ccc;\n  line-height: 1.5;\n}\n\n.modal-warning {\n  color: #ffc107 !important;\n  font-size: 13px;\n  margin-bottom: 20px !important;\n}\n\n.modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n.modal-cancel-button {\n  padding: 10px 16px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.modal-cancel-button:hover:not(:disabled) {\n  background: #5a6268;\n}\n\n.modal-delete-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.modal-delete-button:hover:not(:disabled) {\n  background: #c82333;\n}\n\n.modal-delete-button:disabled,\n.modal-cancel-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.preview-controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 20px;\n  background: #2a2a2a;\n  border-radius: 8px;\n  margin-bottom: 30px;\n}\n\n.preview-controls .play-button {\n  margin-right: 5px;\n}\n\n\n.play-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.play-button:hover {\n  background: #218838;\n}\n\n.generate-video-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.generate-video-button:hover:not(:disabled) {\n  background: #c82333;\n}\n\n.generate-video-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.generate-video-button.generating {\n  background: #ffc107;\n  color: #212529;\n}\n\n.generate-video-button .spinning {\n  animation: spin 1s linear infinite;\n}\n\n.speed-selector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n}\n\n.speed-selector label {\n  font-size: 12px;\n  color: #ccc;\n  margin: 0;\n}\n\n.speed-select {\n  padding: 8px 12px;\n  background: #2a2a2a;\n  color: #fff;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.speed-select:hover {\n  border-color: #007acc;\n}\n\n.speed-select:focus {\n  outline: none;\n  border-color: #007acc;\n  box-shadow: 0 0 0 2px rgba(0, 122, 204, 0.2);\n}\n\n.language-selector {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.language-selector label {\n  font-size: 12px;\n  color: #ccc;\n  margin: 0;\n}\n\n.language-select {\n  padding: 8px 12px;\n  padding-right: 30px;\n  background: #2a2a2a;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 16px;\n  color: #fff !important;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  min-width: 140px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: 500;\n}\n\n.language-select:hover {\n  border-color: #007acc;\n}\n\n.language-select:focus {\n  outline: none;\n  border-color: #007acc;\n  box-shadow: 0 0 0 2px rgba(0, 122, 204, 0.2);\n}\n\n.language-select option {\n  background: #2a2a2a !important;\n  color: #fff !important;\n  padding: 8px 12px;\n  font-weight: 500;\n}\n\n.language-select option:checked,\n.language-select option:selected {\n  background: #007acc !important;\n  color: #fff !important;\n}\n\n/* Additional specificity for better cross-browser support */\nselect.language-select {\n  color: #fff !important;\n  background-color: #2a2a2a !important;\n}\n\nselect.language-select:focus {\n  color: #fff !important;\n  background-color: #2a2a2a !important;\n}\n\n.item-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n}\n\n.item-counter {\n  font-size: 14px;\n  color: #ccc;\n}\n\n.item-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.navigation-controls {\n  display: flex;\n  gap: 10px;\n}\n\n.nav-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: #007acc;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.nav-button:hover:not(:disabled) {\n  background: #005a9e;\n}\n\n.nav-button:disabled {\n  background: #555;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.timeline-items-list {\n  background: #2a2a2a;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.timeline-items-list h3 {\n  margin: 0 0 20px 0;\n  color: #fff;\n  font-size: 18px;\n}\n\n.items-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 15px;\n}\n\n.timeline-item-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 15px;\n  background: #3a3a3a;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px solid transparent;\n  position: relative;\n}\n\n.timeline-item-card:hover {\n  background: #444;\n}\n\n.timeline-item-card.current {\n  border-color: #28a745;\n  background: #2d4a3d;\n}\n\n.item-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #007acc;\n  color: white;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.timeline-item-card.current .item-number {\n  background: #28a745;\n}\n\n.timeline-item-card.has-generated-video {\n  border-left: 4px solid #28a745;\n}\n\n.timeline-item-card.has-generated-video.current {\n  border-left: 4px solid #fff;\n}\n\n/* New classes for language-specific configuration availability */\n.timeline-item-card.has-config-available {\n  border-left: 4px solid #28a745;\n}\n\n.timeline-item-card.has-config-available.current {\n  border-left: 4px solid #fff;\n}\n\n.timeline-item-card.has-config-missing {\n  border-left: 4px solid #dc3545;\n}\n\n.timeline-item-card.has-config-missing.current {\n  border-left: 4px solid #fff;\n}\n\n.item-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.item-type {\n  font-weight: 500;\n  color: #fff;\n  font-size: 14px;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.generated-video-indicator {\n  display: inline-flex;\n  align-items: center;\n  color: #28a745;\n  opacity: 0.8;\n}\n\n.generated-video-indicator svg {\n  filter: drop-shadow(0 0 2px rgba(40, 167, 69, 0.5));\n}\n\n.item-time {\n  font-size: 12px;\n  color: #ccc;\n  margin-top: 2px;\n}\n\n.item-text {\n  font-size: 12px;\n  color: #aaa;\n  margin-top: 4px;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Edit Item Button */\n.edit-item-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 122, 204, 0.9);\n  border: none;\n  border-radius: 4px;\n  padding: 6px;\n  cursor: pointer;\n  opacity: 0;\n  transform: scale(0.8);\n  transition: all 0.2s ease;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.timeline-item-card:hover .edit-item-button {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.edit-item-button:hover {\n  background: #007acc;\n  transform: scale(1.1);\n}\n\n.edit-item-button svg {\n  display: block;\n}\n\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #444;\n  border-top: 4px solid #007acc;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-container h2 {\n  color: #ff6b6b;\n  margin-bottom: 10px;\n}\n\n.error-container p {\n  color: #ccc;\n  margin-bottom: 20px;\n}\n\n/* Quick Preview button in Timeline */\n.timeline-controls {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n  padding: 0 10px;\n}\n\n.quick-preview-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.2s;\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);\n}\n\n.quick-preview-button:hover {\n  background: #218838;\n  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.4);\n  transform: translateY(-1px);\n}\n\n.quick-preview-button svg {\n  flex-shrink: 0;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .preview-header {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n  \n  .preview-controls {\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .preview-controls > button {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .navigation-controls {\n    justify-content: center;\n  }\n  \n  .items-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .preview-main {\n    padding: 20px 15px;\n  }\n}\n\n/* Bulk Render Button Styles */\n.bulk-render-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  min-height: 40px;\n  line-height: 1.2;\n}\n\n.bulk-render-button:hover:not(:disabled) {\n  background: #218838;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.bulk-render-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.8;\n  transform: none;\n}\n\n.bulk-render-button.bulk-rendering {\n  background: #ffc107;\n  color: #212529;\n}\n\n.bulk-render-button .spinning {\n  animation: spin 1s linear infinite;\n}\n\n.bulk-render-button svg {\n  flex-shrink: 0;\n}\n\n/* Integrated Render Controls (Dropdown + Button) */\n.render-controls-group {\n  display: flex;\n  align-items: center;\n  background: #2a2a2a;\n  border: 1px solid #444;\n  border-radius: 4px;\n  overflow: hidden;\n  transition: border-color 0.2s;\n}\n\n.render-controls-group:hover {\n  border-color: #007acc;\n}\n\n.speed-select-integrated {\n  padding: 8px 12px;\n  background: transparent;\n  color: #fff;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n  min-width: 90px;\n  border-right: 1px solid #444;\n}\n\n.speed-select-integrated:focus {\n  background: rgba(0, 122, 204, 0.1);\n}\n\n.render-button-integrated {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #dc3545;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  min-height: 40px;\n  line-height: 1.2;\n}\n\n.render-button-integrated:hover:not(:disabled) {\n  background: #c82333;\n  color: #fff;\n}\n\n.render-button-integrated:disabled {\n  background: #6c757d;\n  color: #fff;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.render-button-integrated.rendering {\n  background: #ffc107;\n  color: #212529;\n}\n\n.render-button-integrated .spinning {\n  animation: spin 1s linear infinite;\n}\n\n.render-button-integrated svg {\n  flex-shrink: 0;\n}\n\n/* Bulk Render Button (Right Aligned) */\n.bulk-render-button-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #28a745;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  line-height: 1.2;\n  margin-left: auto; /* This pushes it to the extreme right */\n}\n\n.bulk-render-button-right:hover:not(:disabled) {\n  background: #218838;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.bulk-render-button-right:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.8;\n  transform: none;\n}\n\n.bulk-render-button-right.bulk-rendering {\n  background: #ffc107;\n  color: #212529;\n}\n\n.bulk-render-button-right .spinning {\n  animation: spin 1s linear infinite;\n}\n\n.bulk-render-button-right svg {\n  flex-shrink: 0;\n}\n\n/* Responsive adjustments for bulk render button and integrated controls */\n@media (max-width: 768px) {\n  .language-selector {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .bulk-render-button {\n    padding: 6px 12px;\n    font-size: 12px;\n    min-height: 36px;\n  }\n  \n  .render-controls-group {\n    flex-direction: column;\n  }\n  \n  .speed-select-integrated {\n    border-right: none;\n    border-bottom: 1px solid #444;\n    min-width: auto;\n    width: 100%;\n  }\n  \n  .render-button-integrated {\n    padding: 6px 12px;\n    font-size: 12px;\n    min-height: 36px;\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Bulk Generation Styles */\n.bulk-gen-button-container {\n  margin-left: 15px;\n}\n\n.bulk-gen-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.bulk-gen-button:hover:not(:disabled) {\n  background: #45a049;\n  transform: translateY(-1px);\n}\n\n.bulk-gen-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Bulk Generation Modal */\n.bulk-gen-modal {\n  min-width: 600px;\n  max-width: 700px;\n}\n\n.bulk-gen-form {\n  margin: 20px 0;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.language-checkboxes {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 12px;\n  background: #2a2a2a;\n  border-radius: 6px;\n  border: 1px solid #444;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 4px;\n  transition: background 0.2s ease;\n}\n\n.checkbox-label:hover {\n  background: #3a3a3a;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.checkbox-text {\n  font-size: 14px;\n  color: #fff;\n}\n\n.voice-model-select {\n  width: 100%;\n  padding: 10px;\n  background: #2a2a2a;\n  color: #fff;\n  border: 1px solid #444;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.voice-model-select:focus {\n  outline: none;\n  border-color: #4CAF50;\n}\n\n/* Progress Display */\n.progress-display {\n  margin-top: 20px;\n  padding: 15px;\n  background: #2a2a2a;\n  border-radius: 6px;\n  border: 1px solid #444;\n}\n\n.progress-info {\n  margin-bottom: 10px;\n  font-size: 14px;\n  color: #fff;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #444;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #4CAF50, #45a049);\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  text-align: center;\n  font-size: 12px;\n  color: #ccc;\n}\n\n.modal-confirm-button {\n  background: #4CAF50;\n  color: white;\n}\n\n.modal-confirm-button:hover:not(:disabled) {\n  background: #45a049;\n}\n\n.modal-confirm-button:disabled {\n  background: #666;\n  cursor: not-allowed;\n}\n\n/* Test Mode Switch */\n.test-mode-switch {\n  display: flex;\n  align-items: center;\n  margin: 0 10px;\n}\n\n.test-mode-switch label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 6px 12px;\n  background: #2a2a2a;\n  border: 1px solid #444;\n  border-radius: 6px;\n  font-size: 14px;\n  color: #fff;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.test-mode-switch label:hover {\n  background: #3a3a3a;\n  border-color: #555;\n}\n\n.test-mode-switch input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n  accent-color: #007acc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
